
export class Event {
    id: number;
    name: string;
    description: string;
    startDate: string;
    endDate: string;
    country: string;
    city: string;
    venue: string;
    booth: number;
    modifiedDate: number;
    products: any;
    departments: any;
    usedOnMobile: any;
    isAddedByManufacturer: any;
    constructor(currentUser: any) {
      this.id = currentUser.id;
      this.name = currentUser.name;
      this.description = currentUser.description;
      this.startDate = currentUser.startDate;
      this.endDate = currentUser.endDate;
      this.country = currentUser.country;
      this.city = currentUser.city;
      this.venue = currentUser.venue;
      this.booth = currentUser.booth;
      this.modifiedDate = currentUser.modifiedDate;
      this.products = currentUser.products;
      this.departments = currentUser.departments;
      this.usedOnMobile = currentUser.usedOnMobile;
      this.isAddedByManufacturer = currentUser.isAddedByManufacturer;
    }
}
